<div class="hotkey">Next time, try holding <span class="key">ESC</span>!</div>
